/***
 * Created on 2023/8/22
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect} from 'react';
import {getCMSUrl} from "../../../../service/common";
import twoStepSvg from "../../../../static/img/security/2-step.svg";
import {useTranslation} from "react-i18next";
import {usePreCheckPassword} from "../../../../hook/pre_check_password";
import attention_svg from '../../../../static/img/utils/ic-sys-attention.svg';


function EmptyTwoStep({dispatch}) {
    const { t } = useTranslation();
    const {checkPassword} = usePreCheckPassword();

    const onSetup = async () => {
        await checkPassword({
            onSuccess: () => dispatch({type: 'toggleShowInitQnapAuthAppSetup', value: true}),
            onError: () => dispatch({type: 'toggleVerifyPassword', value: true, openAfterPassVerified: 'toggleShowInitQnapAuthAppSetup'})
        });
    }

    return (
        <section className="two-step--init">
            <header>{t('@Signing in with 2-step verification@')}</header>
            <div className="comp-attention comp-attention--msg mb-16">
              <span className="attention__ic">
                <img src={attention_svg} alt=""/>
              </span>
                <span>{t('@We recommend enabling this additional layer of security for enhanced protection.@')}</span>
            </div>
            <article className="comp-content-wrapper">
                <div className="two-step--init__col-left">
                    <div className="two-step--init__col-left__desc !mb-24">
                        {t('@2-Step Verification is an additional feature for your QNAP ID\'s security. When you sign in with your password, you must enter a code that you receive via text message or generated by an authenticator app on your mobile device. This extra layer of security helps to protect your account with both your password and your phone.@')}
                        <p><a target='blank'
                              href={`${getCMSUrl()}/faq/all?category=twostepverification`}>{t('@Learn more about 2-step verification.@')}</a>
                        </p>
                    </div>
                    <button className="q-btn q-btn--primary btn-rounded-full" onClick={onSetup}>
                        {t('@Setup now@')}
                    </button>
                </div>
                <div className="two-step--init__col-right"><img src={twoStepSvg} alt=""/>
                </div>
            </article>
        </section>
    );
}

export default EmptyTwoStep;